import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {nextTick, onBeforeMount, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const routerViewContainer = ref<HTMLElement | null>(null);

const isWechat = () => {
  return (String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) === "micromessenger");
};

const route = useRoute()


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})